export default "__VITE_ASSET__CQI_RCbE__"